// Set webpack's runtime publicPath so on-demand chunks load from the plugin's
// build directory (provided by WordPress via cmwChatConfig.assetPath) rather
// than the site root. Must be imported before anything that triggers a chunk.
/* eslint-disable no-undef, camelcase */
const assetPath =
  (typeof window !== "undefined" &&
    window.cmwChatConfig &&
    window.cmwChatConfig.assetPath) ||
  "";

if (assetPath) {
  __webpack_public_path__ = assetPath;
}
